var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRebootIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.901 2.599A8 8 0 000 8h1.5a6.5 6.5 0 0111.339-4.339L10.5 6H16V.5l-2.099 2.099zM14.5 8a6.5 6.5 0 01-11.339 4.339L5.5 10H0v5.5l2.099-2.099A8 8 0 0016 8h-1.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRebootIcon);
export default __webpack_public_path__ + "static/media/reboot-icon.4c284b37fedfee64ec6a61f20746b4fb.svg";
export { ForwardRef as ReactComponent };